// @ts-nocheck
import React, { useState, useContext, useEffect } from 'react';
import Router from 'next/router';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import Storage from '@/utils/storage';
import ManageInventorySubcategory from '@/components/inventory-subcategory/manage';
import { createFileRoute } from '@tanstack/react-router'



function CreateInventorySubcategory() {

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };

    useEffect(() => {
        getAccessStatus();
    }, []);
    
    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace,"/");
        }
    }, [accessStatus]);

    return (
        <div>
            <ManageInventorySubcategory isNew={true} accessStatus={accessStatus} />
        </div>
    );
}

export default CreateInventorySubcategory;

export const Route = createFileRoute('/_authenticated/inventory-subcategory/create')({ component: CreateInventorySubcategory })
